import React from 'react'
import { Link } from 'react-router-dom'
import { useGetTopVendorsQuery } from "../apis/TopVendors";
import { CircularProgress } from '@mui/material';

const TopVendorsAmazon = () => {
  const { 
    data: vendorsData, 
    error, 
    isLoading 
  } = useGetTopVendorsQuery();

    if (isLoading) return (
          <div className="flex-center py-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <CircularProgress />
          </div>
      ); 
  if (error) return <div>Error loading vendors: {error.message}</div>;
  console.log('vendorsData',vendorsData);

  return (
    <section className="top-vendors py-80">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">Top Vendors</h5>
          </div>
        </div>
        <div className="row gy-4 vendor-card-wrapper">
          {vendorsData?.topVendors?.map((vendor) => (
            <div className="col-xxl-3 col-lg-4 col-sm-6" key={vendor.id}>
              <div className="vendor-card text-center px-16 pb-24">
                <div className="">
                  <img
                    src={vendor.coverImageUrl}
                    alt={vendor.shopName}
                    className="vendor-card__logo m-12"
                  />
                  <h6 className="title mt-32">{vendor.shopName}</h6>
                 
                  <Link
                    to={`/vendor/${vendor.uid}`}
                    className="btn btn-main rounded-pill py-6 px-16 text-12 mt-8"
                  >
                    {vendor.shopName}
                  </Link>
                </div>
                <div className="vendor-card__list mt-22 flex-center flex-wrap gap-8">
                  {/* Add product images here if available in API */}
                  {[...Array(5)].map((_, index) => (
                    <div 
                      className="vendor-card__item bg-white rounded-circle flex-center"
                      key={index}
                    >
                      <img 
                        src={vendor.imageLogoUrl}
                        alt={`Product ${index + 1}`} 
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TopVendorsAmazon;